import '.aw{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ck{z-index:20;}.ssr-plugin'
import '.q{margin-bottom:5rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Property } from 'csstype'
import { styled } from 'inlines'
import { RegionViewModel } from 'functions/app/geography/view/region'
import { MunicipalityViewModel } from 'functions/app/geography/view/municipality'
import { RegionalNavBar } from '@app/components/blocks/navbar/regional/RegionalNavBar'
import Column from '@app/components/layout/Column'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'
import Footer from '@app/components/blocks/footer/Footer'
import useMediaQuery from '@app/util/useMediaQuery'
import type {
  MunicipalityFeatures,
  RegionFeatures,
} from '@schema/featureToggle'
import { RegionalHeaderScrollProvider } from '@app/pages/discover/regions/regionalPage/RegionalHeaderScrollContext'

type RegionalPageLayoutBaseProps = {
  children: ReactNode
  gap?: Property.Gap<(string & {}) | 0>
}

export type RegionalPageLayoutProps = RegionalPageLayoutBaseProps &
  (
    | { region: RegionViewModel; tab: RegionFeatures }
    | { municipality: MunicipalityViewModel; tab: MunicipalityFeatures }
  )

export const RegionalPageLayout = ({
  children,
  gap = '2rem',
  ...navProps
}: RegionalPageLayoutProps) => {
  const isMobile = useMediaQuery()

  return (
    <RegionalHeaderScrollProvider>
      <Column
        alignItems="center"
        style={{
          justifyContent: 'center',
          background: 'var(--page-bg)',
        }}
      >
        <div className="aw n ck"
        >
          <TopNavBar
            navBarStyle={{
              position: 'static',
            }}
          />
        </div>
        <RegionalNavBar {...navProps} />

        <ResponsiveContainer
          style={{
            minHeight: '100vh',
            marginBottom: '2rem',
          }}
        >
          <main className="q a b r"
            style={{
              gap: gap,
              paddingInline: isMobile ? 0 : '1rem',
            }}
          >
            {children}
          </main>
        </ResponsiveContainer>

        <Footer />
      </Column>
    </RegionalHeaderScrollProvider>
  )
}
